import React, {useEffect, useState} from "react";
import {tipoParcelaList} from "./tipoParcelaList";
import TextField from "@mui/material/TextField";
import applyRegex from "../../../../utils/applyRegex";
import {InputLabelProps} from "../../../../utils/InputLabelProps";
import Creatable from "react-select/creatable"; // Importe o Creatable

export default function InputsInstallmentType({
                                                  set, index
                                              }) {

    const [multiplicidade, setMultiplicidade] = useState('')
    const [quantidade, setQuantidade] = useState('')

    useEffect(() => {
        set({
            index,
            multiplicidade,
            quantidade,
        })
    }, [multiplicidade, quantidade])

    const handleChangeNumber = (set, value) => {
        const valueToParse = applyRegex(value.replace('e', ''), /\d+/)
        valueToParse.length > 0 ?
            set(parseInt(valueToParse)) : set('')
    };

    const handleChange = (newValue) => {
        setMultiplicidade(newValue?.value); // Atualiza o estado
    };

    return <div className='d-flex'>
        <Creatable
            className="basic-single"
            classNamePrefix="select"
            id="form-select-50"
            required={true}
            defaultValue={multiplicidade}
            isDisabled={false}
            isLoading={false}
            isClearable={true}
            isRtl={false}
            isSearchable={true}
            options={tipoParcelaList}
            onChange={handleChange}
            placeholder={'Multiplicidade de Parcela *'}
            formatCreateLabel={(inputValue) => `Criar "${inputValue}"`} // Personaliza o texto de criação
        />

        <TextField
            label="Quantidade"
            className='d-flex mt-2 mb-1 '
            type="text"
            style={{width: '48%'}}
            value={quantidade}
            inputProps={{
                minLength: 0,
                maxLength: 3,
            }}
            onChange={(e) => handleChangeNumber(setQuantidade, e.target.value)}
            InputLabelProps={InputLabelProps}
            required
        />
    </div>
}